import { getThemeSettings } from '@/queries/theme';
import React from 'react'
import useSWR from 'swr';

const useGetThemeSettings = () => {
    const { data: settings, isLoading, error } = useSWR(
        ["auctions/getThemeSettings"],
        async () => {
            const themeSettings = await getThemeSettings();
            return themeSettings;
        },
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            refreshInterval: 0, // Theme settings don't change during session
            dedupingInterval: 60000, // Cache for 1 minute to prevent duplicate requests
        }
    );

    return { settings, isLoading, error } as any;
}

export default useGetThemeSettings